module.exports = __webpack_public_path__ + "img/szzyk.d85cee20.png";